import * as THREE from "three";

function createRenderer() {

    const renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true,
        precision: 'highp',
        powerPreference: 'high-performance',
        // El seccionado rellena la superficie de corte con el stencil buffer
        // (ver sectionView.js). Es el valor por defecto de three.js, explícito
        // aquí para que no se pierda si alguien toca estas opciones.
        stencil: true,
    });
    // Corte por material, no global: así el plano de sección afecta al modelo
    // pero no al grid del suelo.
    renderer.localClippingEnabled = true;
    renderer.setSize(window.innerWidth, window.innerHeight);
    const isCoarsePointer = window.matchMedia?.('(pointer: coarse)').matches;
    // En tablet/móvil un canvas a DPR 2 de pantalla completa consume bastante
    // GPU; al arrastrar sliders sobre el visor algunos navegadores pierden el
    // contexto WebGL y dejan el 3D blanco hasta recargarlo.
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, isCoarsePointer ? 1.5 : 2))
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    // Tone mapping "PBR Neutral" de Khronos: pensado para visualización de
    // producto. A diferencia de ACES, NO tuerce el tono de los colores
    // saturados (el rojo seguía rojo, no naranja) y mantiene el negro negro,
    // controlando aun así los brillos para que los blancos no se quemen.
    renderer.toneMapping = THREE.NeutralToneMapping;
    renderer.toneMappingExposure = 0.5;

    // Sombras: sin ellas, un llavero plano no muestra profundidad (el relieve
    // no se separa de la base). PCFSoft da bordes suaves; el coste extra es
    // asumible porque la escena es un único objeto pequeño.
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;



    return renderer;
}

export { createRenderer };
